<template>
  <span :class="{ hidden: !showButton }">
    <v-btn class="btn-primary" dark @click="modalOpened = true">
      <div class="text-btn">
        {{ $t('AddInvoiceToChat.AddInvoice') }}
      </div>
    </v-btn>

    <v-dialog :value="modalOpened"
              transition="dialog-bottom-transition"
              @click:outside="modalOpened = false">
      <template>
        <v-card style="max-width: 500px; margin-left: auto; margin-right: auto;">
          <div>
            <ListInvoicesForChat :chat-id="chatId" :other-members="otherMembers" @selected="addInvoiceToChat($event.invoice)" :chat="chat" />
          </div>
        </v-card>
      </template>
    </v-dialog>

  </span>
</template>

<script>
import ListInvoicesForChat from "../components/ListInvoicesForChat";
import ApiRepository from "../repositories/ApiRepository";
import {User} from "../models/user";
export default {
    name: "AddInvoiceToChat",
    components: { ListInvoicesForChat },
    props: {
        showButton: {
            type: Boolean,
            default: true
        },
        chatId: {
            type: String,
            default: ""
        },
        invoiceCreated: {
            type: String,
            default: ""
        },
        otherMembers: {
            type: Array,
            default: new Array()
        },
        chat: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            modalOpened: false
        };
    },
    mounted () {
        if (this.invoiceCreated && this.invoiceCreated !== "") {
            this.addInvoiceToChat(this.invoiceCreated);
        }
    },
    methods: {
        addInvoiceToChat (invoice) {
            ApiRepository.addInvoiceToChat(this.chatId, invoice).then((res) => {
                if (res.data.chat.invoice) {
                    try {
                        ApiRepository.getFilename(res.data.chat.invoice.toString()).then((res) => {
                            ApiRepository.sendFile(this.$user._id.toString(), this.chatId, "", res.data.fileName).then(() => {
                            });
                        });
                        ApiRepository.sendMessage("0", this.chatId, JSON.stringify({message: 'chat.invoice-added', extraMessage: 'chat.invoice-addedExtra', params: {user: (new User(this.$user)).getSingleName(), receiver: this.otherMembers[0].name}}), 'chat.invoice-added').then(() => {
                        });
                    } catch (e) {
                        console.log(e);
                    }
                }

                this.$emit('invoiceAdded');
                ApiRepository.setInvoicePercentage('invoice_added', invoice).then(() => {

                });
            });
        },
    }
};
</script>

<style scoped>
</style>
